import { Link } from "react-router-dom";
import Logo from '../asset/logos.png'
import { useState } from "react";
import '../css/BizTransport.css';

function BizTransport() {

  const [cPage, setCPage] = useState(0); 

  const [activeButtonC, setActiveButtonC] = useState('');


  const cPageRender = () => {

    if (cPage === 0){
      return(
        <div className="tBTwo-b-a">
        </div>
      )
    }else if (cPage === 1){
      return(
        <div className="tBTwo-b-b">
        </div>
      )
    }else if (cPage === 2){
      return(
        <div className="tBTwo-b-c">
        </div>
      )
    }else if (cPage === 3){
      return(
        <div className="tBTwo-b-d">
        </div>
      )
    }else if (cPage === 4){
      return(
        <div className="tBTwo-b-e">
        </div>
      )
    }else if (cPage === 5){
      return(
        <div className="tBTwo-b-f">
        </div>
      )
    }
  }

    const handleClickC = (buttonId) => {
      setActiveButtonC(buttonId);
  };
  

  return (
<div className="transport-full">

<div className="purchase-nav">
    <Link to="/biztransport">
      <img src={Logo} alt="Logo" style={{ width: "140px", padding:"10px 0px", paddingLeft:"14px"}} />
    </Link>
    <ul className="transport-ul">
    <li style={{ display: "inline-block" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>

    <a href="https://www.jungdari.com/member/register.do"
       target="_blank"
       rel="noopener noreferrer">
    <li className="transport-signup">
      중달이닷컴 회원가입
    </li>
    </a>
    </ul>
</div>

<div className="transport-banner">

  <div className="transport-banner-img">

  </div>

</div>

<div className="transport-body">

  <div className="transport-block-one">
  
  </div>

  <div className="transport-block-two">

    <div className="tBlock-two-a">
      <div className={activeButtonC === "turn-on-a" ? "tBTa-a-active" : "tBTwo-a-a"} onClick={() => {handleClickC('turn-on-a'); setCPage(0);}}></div>
      <div className={activeButtonC === "turn-on-b" ? "tBTa-b-active" : "tBTwo-a-b"} onClick={() => {handleClickC('turn-on-b'); setCPage(1);}}></div>
      <div className={activeButtonC === "turn-on-c" ? "tBTa-c-active" : "tBTwo-a-c"} onClick={() => {handleClickC('turn-on-c'); setCPage(2);}}></div>
      <div className={activeButtonC === "turn-on-d" ? "tBTa-d-active" : "tBTwo-a-d"} onClick={() => {handleClickC('turn-on-d'); setCPage(3);}}></div>
      <div className={activeButtonC === "turn-on-e" ? "tBTa-e-active" : "tBTwo-a-e"} onClick={() => {handleClickC('turn-on-e'); setCPage(4);}}></div>
      <div className={activeButtonC === "turn-on-f" ? "tBTa-f-active" : "tBTwo-a-f"} onClick={() => {handleClickC('turn-on-f'); setCPage(5);}}></div>
    </div>

    <div className="tBlock-two-b">
      {cPageRender()}
    </div>

  </div>

  <div className="transport-block-three">
    
  </div>

  <div className="transport-block-four">
  
  </div>

  <div className="transport-block-five">
    <div className="tBlock-five-a">
      <p style={{color:"rgb(255, 227, 100)", fontSize:"36px", fontWeight:"600"}}>위해 지사</p>
      <p><span>기본주소</span> (地址信息) 山东省 威海市 环翠区 草庙子镇</p>
      <p><span>상세주소</span> (详细地址) <span style={{fontSize:"1.2rem", fontWeight:"400"}}>临港区草庙子镇开元西路金沙岭产业园8号楼一楼西侧2楼</span> </p>
      <p><span>우편번호</span> (邮政编码) 264200</p>
      <p><span>연락처</span> (手机号码) 13506310358</p>
      <p><span>수취인</span> (收货人) <span style={{color:"rgb(255, 227, 100)"}}>BPCT</span> +"사서함 번호" <span style={{color:"rgb(255, 227, 100)"}}>(필수작성)</span></p>
    </div>
    <div className="tBlock-five-b">
      <p style={{color:"rgb(255, 227, 100)", fontSize:"36px", fontWeight:"600"}}>이우 지사</p>
      <p style={{color:"rgb(255, 227, 100)"}}>주소 별도문의</p>
      <p>*3CBM 초과하는 화물 진행에 추천드립니다.</p>
      <p>수취인 확인을 위해 별도로 주소 전달드리고 있습니다.</p>
    </div>
  </div>

  <div className="transport-block-six">
    
    </div>

    <div className="transport-block-seven">
      <div className="tBlock-seven-inner">
      <a href="https://jungdari.com/transport/pay.do"
       target="_blank"
       rel="noopener noreferrer">
      <button style={{background:"#5e6164"}}>배송비 확인하기</button></a>
      <a href="https://jungdari.com/transport/apply.do"
       rel="noopener noreferrer">
      <button style={{background:"#5a98d6"}}>신청하기</button></a>
      </div>
    </div>

  </div>




<div className="purchase-block-seven">

  <div className="block-seven-text">

  <div className="seven-top">

      <div className="seven-left">
  <a href="https://jungdari.com/suport/terms.do"
       target="_blank"
       rel="noopener noreferrer">이용약관</a>&nbsp;&nbsp;|&nbsp;&nbsp;  
      <a href="https://jungdari.com/suport/privacy.do"
       target="_blank"
       rel="noopener noreferrer">개인정보취급방침</a>
      &nbsp;&nbsp;|&nbsp;&nbsp;               
      <a href="https://jungdari.com/suport/terms2.do"
       target="_blank"
       rel="noopener noreferrer">개인정보의 수집 및 이용목적</a>
       </div>

       <div className="seven-right">
      고객문의 070-7776-1688
      </div>
  </div>

  <div className="seven-bottom">

      <div className="footer">

      <div className="footer-left">
  <p>상호:(주)빅파이씨앤티 | 사업자 등록번호 : 169-81-00496 | 전화번호 : 070-7776-1688 | 팩스번호 : 032-714-3850</p>
  <p>경기도 부천시 조마루로 385번길 122 삼보테크노타워 2702-3호 (주)빅파이씨앤티</p>
  <p>대표이사: 이중엽 | 통신판매 신고번호 : 제 2021-경기부천-1209호 | 개인정보보호책임자 : 양지연 | 메일: pi@jungdari.com</p>
  <p>Copyrights2020ⓒBigpieC&T. All Rights Reserved</p>
  </div>

  <div className="footer-right">
      <div className="footer-img"></div>
  </div>

  </div>

  </div>
  </div>
    
</div>


</div>
  );
}

export default BizTransport;
